<template>
  <div>Login Successful, redirecting...</div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions('authStore', ['oidcSignInCallback']),
  },
  created() {
    // This callback will be executed after manual login but not silent login
    this.oidcSignInCallback()
      .then((redirectPath) => {
        // The prev_path in SessionStorage is recorded when users manually log in.
        const path = sessionStorage.getItem('prev_path');

        // The value of redirectPath is always '/' here
        this.$router.push(path || redirectPath);
      })
      .catch((err) => {
        console.error(err);
        this.$router.push('/'); // Handle errors any way you want
      });
  },
};
</script>

<style lang="scss" scoped>
div {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
